<template lang="pug">
  v-row(justify="center")
    v-col(cols="12" sm="8" md="6")
      v-row(no-gutters align="center" justify="center")
        v-col(v-for="btn in buttons" :key="btn" cols="4")
          .button.mx-auto.mb-4(@click="handleInput(btn)")
            .text-2xl.number-padding(v-if="isNumber(btn)") {{ btn }}
            .text-lg(v-else)
              .clear-padding(v-if="btn === 'Clear'") {{ btn }}
              v-icon.ma-4(v-else size="35" color="black") $yzi-delete
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      buttons: ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'Clear', '0', 'Delete'],
      currentNumber: '',
    }
  },
  methods: {
    isNumber(value) {
      return !isNaN(value)
    },
    handleInput(value) {
      if (value === 'Clear') {
        this.handleClear()
        return
      }
      if (value === 'Delete') {
        this.handleDelete()
        return
      }
      this.handleAppendNumber(value)
    },
    handleClear() {
      this.$emit('input', '')
      this.currentNumber = ''
    },
    handleDelete() {
      this.currentNumber = this.currentNumber.slice(0, -1)
      this.$emit('input', this.currentNumber)
    },
    handleAppendNumber(number) {
      this.currentNumber += number
      this.$emit('input', this.currentNumber)
    },
  }
}
</script>

<style scoped>
.button {
  width: 70px;
  height: 70px;
  border-radius: 50% !important;
  background-color: #EEE;
}

.number-padding {
  padding: 18px 27px;
}

.clear-padding {
  padding: 20px 12px;
}
</style>